import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoSliderMixin from './KendoSliderMixin'

export default {
    name: 'kendo-slider',
    mixins: [ KendoSliderMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        if(this.v3) {
            return h('input',{
                value: this.value
            })
        } else {
            return h('input',{
                props: {
                    value: this.value
                }
            })
        }
       
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSlider/index.js